const PostbackSendFormLangKey = [
	'field_sub_id_label',
	'field_sub_id_placeholder',
	'field_postback_status_label',
	'field_postback_status_placeholder',
	'field_postback_currency_label',
	'field_postback_currency_placeholder',
	'field_postback_amount_label',
	'field_postback_amount_placeholder',
	'msg_postback_send_success',
	'msg_postback_send_error',
	'btn_send'
] as const

type IPostbackSendFormLangKey = typeof PostbackSendFormLangKey[number]

export type IPostbackSendFormLang = {
	postback_send_form: Record<IPostbackSendFormLangKey, string>
}

const langEntries = PostbackSendFormLangKey.map(
	(key: IPostbackSendFormLangKey) => [key, `postback_send_form.${key}`]
)

const langObj: Record<IPostbackSendFormLangKey, string> = Object.fromEntries(langEntries)

export const POSTBACK_SEND_FORM_LANG_KEY: IPostbackSendFormLang = {
	postback_send_form: langObj
}